module.exports = __webpack_public_path__ + "img/child-01.0097d9bb.svg";